import dayjs from 'dayjs';
import CalendarTodayRounded from '@mui/icons-material/CalendarTodayRounded';
import ContactPhoneRounded from '@mui/icons-material/ContactPhoneRounded';
import RouteRounded from '@mui/icons-material/RouteRounded';
import Notice from 'components/common/Notice/Notice';
import FactList from 'components/common/FactList/FactList';

// A Plan's day, route and Emergency Contact, flagging one whose Emergency
// Contact was deleted. children adds further facts to the list.
const PlanFacts = ({ plan, today, children }) => (
  <>
    <FactList>
      <li>
        <CalendarTodayRounded aria-hidden="true" />
        <span>
          {plan.planned_date === today
            ? 'Today'
            : dayjs(plan.planned_date).format('ddd D MMM YYYY')}
          , starting about {plan.planned_start_time}
        </span>
      </li>
      <li>
        <RouteRounded aria-hidden="true" />
        <span>
          {plan.start_location}: {plan.trail_option_name}
        </span>
      </li>
      {!plan.needs_emergency_contact && (
        <li>
          <ContactPhoneRounded aria-hidden="true" />
          <span>
            Emergency Contact: {plan.emergency_contact_name ?? '(deleted)'}
          </span>
        </li>
      )}
      {children}
    </FactList>
    {plan.needs_emergency_contact && (
      <Notice tone="danger" title="This Plan needs an Emergency Contact">
        Its contact was deleted. Edit the Plan to choose a new one before you
        start.
      </Notice>
    )}
  </>
);

export default PlanFacts;
